import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { IStepStatus } from './Step';

interface StepNumberProps {
  status: IStepStatus;
  step: number;
}

export const StepNumber: React.FC<StepNumberProps> = memo(
  ({ status = 'default', step }) => {
    const isActive = useMemo(
      () => status === 'filled' || status === 'active',
      [status]
    );

    return (
      <div
        className={classNames(
          'rounded-[14px] bg-neutral-200 w-[40px] h-[40px] overflow-hidden flex items-center justify-center shrink-0',
          {
            'bg-green1': isActive,
          }
        )}
      >
        <div
          className={classNames(
            'bg-white w-[89%] h-[89%] rounded-xl flex justify-center items-center text-sm font-medium text-neutral-300 ml-[0.5px]',
            {
              '!text-neutral-900 font-medium': isActive,
              'bg-green1 !text-white': status === 'filled',
            }
          )}
        >
          {step}
        </div>
      </div>
    );
  }
);
